import * as yup from 'yup'
import { ComponentType } from 'react'
import fields, { defaultValues, ComponentName } from './fields'
import nestedProperty from 'nested-property'

import {
  FormSchema,
  FormFieldProps,
} from '../../../types/frontend/form'

import {
  flattenSchema as flattenSchemaUtil,
} from '../../../utils/form'

let globalFields: Record<string, React.FC<React.PropsWithChildren<FormFieldProps>>> = fields
let globalDefaultValues: Record<string, any> = defaultValues

export const setGlobalFields = (passedFields: Record<string, React.FC<React.PropsWithChildren<FormFieldProps>>>) => {
  globalFields = passedFields
}

export const setGlobalDefaultValues = (passedDefaultValues: Record<string, any>) => {
  globalDefaultValues = passedDefaultValues
}

export const flattenSchema = flattenSchemaUtil

export const getComponent = (component: ComponentName | ComponentType<React.PropsWithChildren<unknown>>) => {
  let Component = typeof(component) === 'string' ?
      globalFields[component] :
      component

  if(!Component) Component = fields.text

  return Component
}

export const getInitialValues = (schema: FormSchema, initialValues: any) => {
  const flatSchema = flattenSchema(schema)
  return flatSchema
    .filter(field => field.cosmetic ? false : true)
    .reduce((all, field) => {
      if(field.divider) return all
      const existing = nestedProperty.get(all, field.id)
      const component = field.component || 'text'
      if(!existing && typeof(component) === 'string') {
        nestedProperty.set(all, field.id, globalDefaultValues[component as ComponentName])
      }
      return all
    }, Object.assign({}, initialValues))
}

export const getDynamicFormValidation = (validation: Record<string, string>): yup.ObjectSchema<any> => {
  const parts: Record<string, any> = {}
  Object.keys(validation).forEach(key => {
    const context = {
      yup,
      result: null,
    }
    function getValidationHandler() {
      eval(`this.result = this.yup.${validation[key]}`)
    }
    getValidationHandler.call(context)
    parts[key] = context.result
  })
  return yup.object().shape(parts)
}

export const createYupSchema = (schema: FormSchema) => {
  const flatSchema = flattenSchema(schema)
  const obj = flatSchema
    .filter(field => field.cosmetic ? false : true)
    .reduce((all, field) => {
      const {
        id,
        validationType,
        validations,
      } = field
      if (!yup[validationType]) {
        return all
      }
      let validator = yup[validationType]()
      validations.forEach(validation => {
        const { params, type } = validation
        if (!validator[type]) {
          return
        }
        validator = validator[type](...params)
      })
      all[id] = validator
      return all
    }, {})
  return yup.object().shape(obj)
}

export default {
  flattenSchema,
  getComponent,
  getInitialValues,
  getDynamicFormValidation,
  createYupSchema,
}